import { view } from '../net/client.ts';
import { ConnectionBanner } from './components/Chrome.tsx';
import { Confessions } from './screens/Confessions.tsx';
import { Final } from './screens/Final.tsx';
import { Home } from './screens/Home.tsx';
import { Investigation } from './screens/Investigation.tsx';
import { Lobby } from './screens/Lobby.tsx';
import { Plume } from './screens/Plume.tsx';
import { Publication } from './screens/Publication.tsx';
import { Reveal } from './screens/Reveal.tsx';
import { Writing } from './screens/Writing.tsx';

function Screen() {
  const current = view.value;
  if (!current) return <Home />;
  const { phase } = current;
  // Keys remount a screen whenever its subject changes, so local drafts never leak across.
  const key = `${current.code}:${current.round}:${phase.name}`;
  switch (phase.name) {
    case 'lobby':
      return <Lobby key={key} />;
    case 'confessions':
      return <Confessions key={key} current={current} phase={phase} />;
    case 'writing':
      return <Writing key={key} current={current} phase={phase} />;
    case 'publication':
      return <Publication key={key} current={current} />;
    case 'investigation':
      return <Investigation key={`${key}:${phase.articleId}`} current={current} phase={phase} />;
    case 'reveal':
      return <Reveal key={`${key}:${phase.articleId}`} current={current} phase={phase} />;
    case 'plume':
      return <Plume key={key} current={current} phase={phase} />;
    case 'final':
      return <Final key={key} current={current} phase={phase} />;
  }
}

export function App() {
  return (
    <>
      <ConnectionBanner />
      <Screen />
    </>
  );
}
